// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1Z0HR","cardContent":"card_cardContent__u9VVe"};